import { Container, Box, Typography, Stack } from "@mui/material";
import SectionHeader from "../components/SectionHeader";

interface DecisionGuideSectionProps {
  bgcolor?: string;
}

const decisionGuide = [
  {
    condition: "If you want better consistency, fewer follow-ups, and more attention to detail.",
    recommendation: "Professional (Recommended)",
  },
  {
    condition: "If you have custom requirements or want your property prepared exactly to your standards.",
    recommendation: "White-Glove",
  },
  {
    condition: "If you need a reliable Airbnb turnover at the most affordable price.",
    recommendation: "Standard",
  },
];

export default function DecisionGuideSection({ bgcolor = "background.default" }: DecisionGuideSectionProps) {
  return (
    <Box sx={{ width: "100vw", bgcolor }}>
      <Container
        component="section"
        maxWidth="lg"
        sx={{
          maxWidth: "1000px !important",
          py: { xs: 4, md: 7 }, 
          px: { xs: 2, sm: 3, md: 4 } 
        }}
      >
        <SectionHeader title="Which package should I choose?" />

      <Stack spacing={{ xs: 2, md: 2.5 }}>
        {decisionGuide.map((guide, index) => (
          <Box
            key={index}
            sx={{
              p: { xs: 2.5, md: 3 },
              bgcolor: "rgba(76, 175, 80, 0.03)",
              borderRadius: "12px",
              borderLeft: "4px solid #4CAF50",
              transition: "all 0.2s ease",
              "&:hover": {
                bgcolor: "rgba(76, 175, 80, 0.06)",
                transform: "translateX(4px)"
              }
            }}
          >
            <Typography
              variant="body2"
              sx={{
                lineHeight: 1.7,
                color: "#333",
                fontSize: { xs: "0.9rem", md: "0.95rem" },
              }}
            >
              {guide.condition} → <strong>{guide.recommendation}</strong>
            </Typography>
          </Box>
        ))}
      </Stack>
      </Container>
    </Box>
  );
}
